import React from "react";
import { useLocation } from "react-router-dom";
import { IonIcon, useIonRouter } from "@ionic/react";
import {
  chatbubblesOutline,
  compassOutline,
  createOutline,
  alertCircleOutline,
} from "ionicons/icons";
import "./DesktopSidebar.css";

interface NavItem {
  label: string;
  icon: string;
  path: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: "AI Chat", icon: chatbubblesOutline, path: "/tabs/home" },
  { label: "Navigate", icon: compassOutline, path: "/tabs/explore" },
  { label: "Emergency", icon: alertCircleOutline, path: "/tabs/emergency" },
  { label: "Contribute", icon: createOutline, path: "/tabs/contribute" },
];

/**
 * Desktop-only left navigation rail. Hidden on mobile/native via CSS
 * (see DesktopSidebar.css), where the Ionic bottom tab bar takes over.
 */
const DesktopSidebar: React.FC = () => {
  const location = useLocation();
  const router = useIonRouter();

  const isActive = (path: string) => location.pathname.startsWith(path);

  const navigate = (path: string) => {
    if (location.pathname.startsWith(path)) return;
    // useIonRouter integrates with IonTabs so tab views switch correctly,
    // which a bare history.push() does not do from outside the tab bar.
    router.push(path, "none");
  };

  return (
    <aside className="web-sidebar" aria-label="Primary navigation">
      <div className="web-sidebar-brand">
        <span className="web-sidebar-logo-shell" aria-hidden="true">
          <img
            className="web-sidebar-logo"
            src="/assets/icon/icon.png"
            alt="Bacolod AI"
          />
        </span>
        <div className="web-sidebar-brand-text">
          <span className="web-sidebar-title">Bacolod AI</span>
          <span className="web-sidebar-subtitle">City of Smiles</span>
        </div>
      </div>

      <nav className="web-sidebar-nav">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              type="button"
              className={`web-nav-item ${active ? "is-active" : ""}`}
              onClick={() => navigate(item.path)}
              aria-current={active ? "page" : undefined}
            >
              <span className="web-nav-indicator" aria-hidden="true" />
              <IonIcon className="web-nav-icon" icon={item.icon} />
              <span className="web-nav-label">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="web-sidebar-footer">
        <span className="web-sidebar-tagline">
          Your local guide to Bacolod City
        </span>
      </div>
    </aside>
  );
};

export default DesktopSidebar;
